import React from 'react';
import '../styles/contact.css';

export default function Contact() {
  return (
    <section id="contact">
      <h1 className="contact-title">Contact Me</h1>

      <div className="contact-info-upper-container">

        {/* Gmail */}
        <div className="contact-info-container">
          <a
            href="https://mail.google.com/mail/u/0/?fs=1&to=ashwindumane0@gmail.com&tf=cm"
            target="_blank"
            rel="noopener noreferrer"
            title="Send Email via Gmail"
          >
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/gmail.svg"
              alt="Gmail"
              className="icon"
            />
          </a>
        </div>

        {/* LinkedIn */}
        <div className="contact-info-container">
          <a
            href="https://www.linkedin.com/in/ashwindumane/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/linkedin.svg"
              alt="LinkedIn"
              className="icon"
            />
          </a>
        </div>

        {/* GitHub */}
        <div className="contact-info-container">
          <a
            href="https://github.com/ashwindumane"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/github.svg"
              alt="GitHub"
              className="icon"
            />
          </a>
        </div>

        {/* Instagram */}
        <div className="contact-info-container">
          <a
            href="https://www.instagram.com/ashwin_kshatriya_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg"
              alt="Instagram"
              className="icon"
            />
          </a>
        </div>

        {/* Dev.to */}
        <div className="contact-info-container">
          <a
            href="https://dev.to/ashwin_dumane"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/devdotto.svg"
              alt="Dev Community"
              className="icon"
            />
          </a>
        </div>

        {/* Credly */}
        <div className="contact-info-container">
          <a
            href="https://www.credly.com/users/ashwin-dumane/badges#credly"
            target="_blank"
            rel="noopener noreferrer"
            title="View my Credly badges"
          >
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/credly.svg"
              alt="Credly"
              className="icon"
            />
          </a>
        </div>

      </div>
    </section>
  );
}
